// extracted by mini-css-extract-plugin
export default {"otpWrap":"otpInput_otpWrap__Db7qF","otpBox":"otpInput_otpBox__j29X6"};